'use client';

import { Loader2 } from 'lucide-react';
import { useEffect, useState } from 'react';

interface PageLoaderProps {
  isLoading?: boolean;
  backgroundColor?: string;
  spinnerColor?: string;
  spinnerSize?: number;
  message?: string;
}

export default function PageLoader({
  isLoading = true,
  backgroundColor = 'bg-transparent',
  spinnerColor = 'text-on-color',
  spinnerSize = 60,
  message = 'Loading...',
}: PageLoaderProps) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isLoading) {
      setShow(true);
    } else {
      const timer = setTimeout(() => setShow(false), 300);
      return () => clearTimeout(timer);
    }
  }, [isLoading]);

  if (!show) return null;

  return (
    <div
      className={`fixed inset-0 z-50 flex flex-col items-center justify-center ${backgroundColor} backdrop-blur-sm transition-all duration-300`}
      role="alert"
      aria-busy="true"
    >
      <Loader2 className={`animate-spin ${spinnerColor}`} size={spinnerSize} />
      {message && <p className={`mt-4 text-lg font-medium ${spinnerColor}`}>{message}</p>}
    </div>
  );
}
